<template>
    <div style="background: #F9F9F9;">
        <!--    <img src="./design.svg" alt="" style="width:100%">-->
        <div class="printBanner">
            <el-carousel
                indicator-position="none"
                :interval="5000"
                :height="imgHeight + 'px'"
            >
                <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                    <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
                    <img :src="item.value" alt="" style="width: 100%" ref="image"/>
                    </a>
                    <a v-else href="javascript:void(0)">
                    <img :src="item.value" alt="" style="width: 100%" ref="image"/>
                    </a>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="newRq">
            <div class="newRqCont">
                <div class="flex newRqCont_text">
                    <p>最新需求</p>
                    <div class="newRqCont_textSS">
                        <div class="newDemandListItem" @click.stop="handleSectionClick($event)">
                            <vue-seamless-scroll
                                :data="newDemandList"
                                :class-option="defaultOption"
                                ref="seamlessScroll"
                                v-if="newDemandList.length > 1"
                                class="seamlessScroll"
                                style="cursor: pointer;"
                            >
                <span v-for="(item,index) in newDemandList" :key="index" :data-id="item.uuid" @click="getDetailMessage(item.uuid)">{{
                  item.title| ellipsis
                }}</span>
                            </vue-seamless-scroll>
                            <span
                                v-if="newDemandList.length <= 1"
                                v-for="item in newDemandList"
                                style="padding-right: 50px" @click="getDetailMessage(item.uuid)">
                            {{ item.title}}</span
                            >
                        </div>
                    </div>
                </div>
                <div class="sMenuBtn">
                    <el-button @click="isIdentityUser">发需求</el-button>
                    <el-button @click="isDesigner" type="primary" v-if="designer">设计师入驻</el-button>
                </div>
            </div>
        </div>
        <div class="container">
            <section>
                <div class="printTitle">
                    找大师 <span class="more" @click="printMore(1)"> 查看更多 > </span>
                </div>
                <el-row :gutter="30">
                    <el-col :span="12" v-for="(items, index) in designPeo" :key="index">
                        <el-card class="box-card lookingMasterCard" shadow="hover">
                            <div class="fMaster">
                                <div class="lookingMasterCardLeft">
                                    <div class="avatar" @click="getDesigner(items.uuid)">
                                        <!-- <img :src="items.imgs" alt=""/> -->
                                        <img v-if="items.imgs" :src="items.imgs"  alt=""/>
                                        <!-- <img v-else src="../../assets/设计市场/头像1.jpeg"  alt=""/> -->
                                        <img v-else src="../../assets/users.png"  alt=""/>
                                    </div>
                                    <div class="fMasterInfo">
                                        <p class="fMasterInfoName" @click="getDesigner(items.uuid)">{{ items.name }}
                                        <!-- <img v-for="(item,index) in items.designerLevels" src="../../assets/模型库/designIcon.png" :src="item.levelIconUrl" title="" :title="item.name" style="width: 55px;height: 20px;margin-left: 5px;"><span></span></p> -->
                                        <img v-for="(item,index) in items.designerLevels" :key="index"
                                            :src="item.levelIconUrl? item.levelIconUrl :require('../../assets/模型库/designIcon.png')"
                                            :title="item.name"
                                            style="height: 20px;margin-left: 5px;"/>
                                        </p>
                                        <p class="fMasterInfoAddr">
                                            <span>{{ items.provinces }} | {{ items.city }}</span>
                                        </p>
                                        <p class="fMasterInfoAddr">
                                            <span>作品：</span><span>{{ items.works }}</span>
                                        </p>
                                        <div class="fMasterBtn" style="margin-top: 10px">
                                            <el-button size="small" v-if="!items.hasLiked" @click="liked(items)">
                                                <i
                                                    class="iconfont icon-aixin1"
                                                    style="font-size: 12px; padding-right: 3px"
                                                ></i>
                                                关注
                                            </el-button>
                                            <el-button size="small" v-if="items.hasLiked" @click="liked(items)">
                                                <i
                                                    class="iconfont icon-aixin"
                                                    style="font-size: 12px; padding-right: 3px"
                                                ></i>
                                                已关注
                                            </el-button>
                                            <el-button @click.stop="startChat(items.userId)" size="small" icon="el-icon-chat-dot-square"
                                            >和TA聊天
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="lookingMasterCardRight">
                                    <img v-if="items.imgsMess"
                                        style="width: 216px; height: 162px"
                                        :src="items.imgsMess"
                                        fit="fill"
                                    />
                                    <!-- 默认的图 -->
                                    <img v-else style="width: 216px; height: 162px" src="../../assets/设计市场/default.jpg" alt=""/>
                                    <!-- <el-image v-else
                                        style="width: 216px; height: 162px"
                                        src="../../assets/设计市场/default.jpg"
                                        fit="fit"
                                    >
                                    </el-image> -->
                                </div>
                            </div>
                            <div class="fMasterDesc">
                                <p><span>个人简介：</span>{{ items.introduction }}</p>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </section>
            <div style="margin-top: 30px" class="bannerImgs">
                <div class="bannerImgs_carousel">
                    <el-carousel :interval="5000" height="286px">
                        <el-carousel-item v-for="(item,index) in bannerList_imgs" :key="index">
                            <img
                                :src="item.value"
                                style="width: 100%; height: 100%"
                                @click="getImgsDetails(index)"
                                class="bannerImgs_img"
                            />
                        </el-carousel-item>
                    </el-carousel>
                </div>

                <div class="bannerImgs_more" @click="handleActiveList">查看更多 ></div>
            </div>
            <section>
                <div class="printTitle" style="margin-top: 30px">
                    找需求
                    <span class="more" @click="printMore(2)"> 查看更多 > </span>
                </div>
                <el-row :gutter="30">
                    <el-col :span="6" v-for="(items, index) in demandList" :key="index">
                        <el-card class="box-card" shadow="hover">
                            <div :class="items.state === '已过期'?'pastTag listTag':items.state === '已验收'?'finishTag listTag':'listTag'">{{ items.state == '审核通过' ? '询价中' : items.state }}</div>
                            <h4 class="rqTitle">{{ items.title }}</h4>
                            <div class="rqPrice">
                                <span class="tagBlue">预算</span>
                                <span><i>¥</i> {{ items.money }}</span>
                            </div>
                            <dl class="rqDetail">
                                <dt v-if="items.describe != null">模型尺寸：</dt>
                                <dd v-if="items.describe != null">
                                    {{ items.describe }}
                                </dd>
                                <dt v-if="items.describe == null">需求类型：</dt>
                                <dd v-if="items.describe == null&&items.type=='DESIGN'">
                                    平面设计-{{items.name}}
                                </dd>
                                 <dd v-if="items.describe == null&&items.type=='MODEL'">
                                    三维设计-{{items.name}}
                                </dd>
                                <dt>需求描述：</dt>
                                <dd
                                    style="
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    height:72px;
                  "
                                >
                                    {{ items.size }}
                                </dd>
                                <dt>期望交期：</dt>
                                <dd>{{ items.date }}</dd>
                            </dl>
                            <div class="rqFooter">
                                <span @click="getDetailMessage(items.uuid)">查看详情</span>
                                <span @click="startChat(items.creator)">立即联系</span>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </section>
        </div>
        <!-- 地图 -->
        <div class="printTitle" align="center" style="margin-top: 30px">
            寻找附近设计师
        </div>
        <div class="mapPosition" @click="mapDivClick">
            <div class="mapInput flex">
                <el-input
                    placeholder="寻找附近设计师"
                    v-model="inputMapParam"
                    clearable
                    @clear="getClearMap"
                >
                </el-input>
                <!-- <input type="text" placeholder="搜园区" v-model="inputMapParam" /> -->
                <i class="iconfont" @click="getParkAddrByName()">&#xe6a8;</i>
            </div>
            <!-- 弹窗 -->
            <div
                class="flex maps"
                :style="{ top: mapPopX, left: mapPopY }"
                v-show="mapShow"
            >
                <div class="mapImg">
                    <el-image v-if="mapParkDetail.imgs" :src="mapParkDetail.imgs"></el-image>
                    <img v-else src="../../assets/设计市场/头像1.jpeg" alt="">
                    <div class="mapImgIcon">
                      <i class="el-icon-location"></i>
                      <p>{{mapParkDetail.provinces}}·{{mapParkDetail.city}}</p>
                    </div>
                </div>
                <div class="mapMess">
                    <p class="mapMessT">{{ mapParkDetail.name }}</p>
                    <div class="flex mapMessWork">
                      <div class="flex">
                        <p>作品</p>
                        <span>{{mapParkDetail.works}}</span>
                      </div>
                      <i class="gangMess"></i>
                      <div class="flex">
                        <p>粉丝</p>
                        <span>{{mapParkDetail.fans}}</span>
                      </div>
                      <i class="gangMess"></i>
                      <div class="flex">
                        <p>订单</p>
                        <span>{{mapParkDetail.order}}</span>
                      </div>
                    </div>
                    <div class="mapMessText">{{mapParkDetail.introduction}}</div>
                    <div class="mapMessBut">
                        <button v-if="!mapParkDetail.hasLiked" @click="liked(mapParkDetail)">
                            关注TA
                        </button>
                        <button v-if="mapParkDetail.hasLiked" @click="liked(mapParkDetail)">
                            已关注
                        </button>
                        <button @click.stop="getDesigner(mapParkDetail.uuid)">
                            查看详情
                        </button>
                    </div>
                </div>
            </div>

            <div ref="ChinaMap" :style="{ width: '100%', height: '600px' }"></div>
        </div>

      <!--聊天窗口-->
      <chat-dialog ref="chatDialogRef"></chat-dialog>

    </div>
</template>

<script>
import {
  getBannerList,
  designerList,
  designerByUserId,
  getNewcurrent,
  like,
  getRongCloudUser,
  couldIn, designerListByPage, queryDemandList
} from "../../utils/interface";
    import {mapState, mapMutations} from "vuex";
    import vueSeamlessScroll from "vue-seamless-scroll";

    import chatDialog from '../chat/chatDialog'

    export default {
        //   设计市场
        name: "design",
        metaInfo: {
            title: '3D模型设计交易平台——3D打印模型设计接单|增材云设计市场', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '3D打印|3D模型设计|3D打印设计服务|三维模型设计定制|手办模型设计服务|3D模型设计接单|3D模型优化|3D模型渲染'
            },
                {                 // set meta
                    name: 'description',
                    content: '3D模型设计师免费入驻接单，千余名设计师任选，手办模型、艺术摆件模型、工业零件模型风格任选，第三方监管交易有保障。增材云，聚合3D打印设计师、3D打印厂商、3D打印原料、3D打印模型、3D打印软件及课程等6大资源。'
                }
            ],
        },
        components: {vueSeamlessScroll, chatDialog},
        data() {
            return {

                designer: false,
                imgHeight: "",
                imgHeightsetIn: null,
                groupCode: "design_banner",
                groupCodeImg: "SJDS",
                //   groupCode: "SOLUTION_BANNER", // 类别

                bannerList: [],
                bannerList_imgs: [],
                url: "",
                fit: "",
                designPeo: [
                ],
                designPeo1: [
                ],
                demandList: [
                ],
                // 地图
                setIn: null, // 定时器
                ifbox: false,
                TipsList: [],
                inputMapParam: "",
                mapPopX: "0px",
                mapPopY: "0px",
                mapdata: [],
                mapShow: false,
                //地图对象数据
                mapParkDetail: {
                    parkName: "",
                    uuid: "",
                    imageURL: "",
                },
                // 最新需求
                newDemandList: [
                ],
                userMessages: {},
            };
        },
        filters: {
                ellipsis(value) {

                if (value.length > 25) {
                    return value.slice(0, 25) + "...";
                }
                return value;
                }
            },
        computed: {
            ...mapState({
                isTokenDoor: "isTokenDoor",
                isLogin: "isLogin",
                isUsermessage: "isUsermessage"
            }),
            defaultOption() {
                return {
                    step: 0.5, // 数值越大速度滚动越快
                    limitMoveNum: this.newDemandList.length, // 开始无缝滚动的数据量
                    hoverStop: true, // 是否开启鼠标悬停stop
                    direction: 2, // 0向下 1向上 2向左 3向右
                    openWatch: true, // 开启数据实时监控刷新dom
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                };
            },
        },
        mounted() {
            window.addEventListener("resize", () => {
                if(this.$refs.image){
                    this.imgHeight = this.$refs.image[0].height;
                }
            });
            getNewcurrent()
                .then((res) => {
                    this.userMessages = res;
                    if(res.identity == 'ENTERPRISE' || res.identity == 'STAFF'){
                        this.designer = false;
                    }else{
                        this.designer = true;
                    }
                })
                .catch((err) => {
                    // console.log(err);
                });
        },
        beforeMount() {
          this.getTopDesigner();
          this.getDesigners();
          this.getDemands();
          this.setIn = setInterval(() => {
            if (this.isTokenDoor === true) {
              clearInterval(this.setIn);
              this.getBannerList();
              this.getBannerImgs()
            }
          }, 500);
        },
        methods: {
            ...mapMutations(["isLoginVuex"]),
            handleActiveList(){
                let routeData = this.$router.resolve({
                    name: "activeList",
                });
                window.open(routeData.href, "_blank");
            },
            imgLoad() {
                this.$nextTick(function () {
                    // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
                    // this.imgHeight = (document.body.clientWidth * 1) / 4;
                    this.imgHeightsetIn = setInterval(() => {
                        if (this.imgHeight == 0) {
                            // console.log('jj', this.$refs.image1);
                            if(this.$refs.image){
                                this.imgHeight = this.$refs.image[0].height;
                            }
                        } else {
                            clearInterval(this.imgHeightsetIn);
                            // console.log(6666, this.imgHeight);
                        }
                    }, 520);
                });
            },
            mapDivClick(e) {
                // console.log(e.offsetX, e.offsetY);
                // this.mapPopY = e.offsetX + "px";
                // this.mapPopX = e.offsetY + "px";
                // 计算
                let comTop = 500 - 130;
                let comBottom = this.$refs.ChinaMap.offsetWidth - 610;
                // 计算高度是否超过盒子高度
                if (comTop < e.offsetY) {
                    this.mapPopX = comTop + "px";
                } else {
                    this.mapPopX = e.offsetY + "px";
                }
                // 计算宽度是否超过盒子宽度

                if (comBottom < e.offsetX) {
                    this.mapPopY = comBottom + "px";
                    // console.log(444, this.mapPopY);
                } else {
                    this.mapPopY = e.offsetX + "px";
                }
            },
            getParkAddrByName() {
                if(this.inputMapParam){
                    this.mapdata = this.designPeo1.filter(res=>{
                        // return res.name.includes(this.inputMapParam.split(''))
						if(res.name.includes(this.inputMapParam.split('')) || res.name.includes(this.inputMapParam)){
							return res.name
						}
                    })
                } else {
                    this.mapdata = this.designPeo1
                }
                this.initEcharts();
            },
            //开发js   尤其要注意执行顺序和时间，异步和同步
            getMapData() {
                this.mapdata = this.designPeo1;
                this.initEcharts();
            },
            getClearMap() {
                this.getParkAddrByName();
            },
            dealWithData() {
                let newStr = JSON.parse(JSON.stringify(this.mapdata));
                let data = newStr;
                return data;
            },
            // 地图
            initEcharts() {
                var data1 = this.dealWithData();
				console.log(data1)
                var echarts = this.$echarts.init(this.$refs.ChinaMap); //获取到容器的节点，初始化echarts实例
                var option = {
                  tooltip: {
                    // 设置鼠标移上去的弹框显示效果
                    padding: 0,
                    // backgroundColor: "transparent",
                    formatter: (params) => {
                      let htmlStr = ``;
                      return htmlStr;
                    },
                  },
                  legend: {
                    orient: "vertical",
                    top: "9%",
                    left: "5%",
                    icon: "circle",
                    data: [],
                    selectedMode: "single",
                    selected: {},
                    itemWidth: 12,
                    itemHeight: 12,
                    itemGap: 30,
                    inactiveColor: "#b6d7ff",
                    textStyle: {
                      color: "#ec808d",
                      fontSize: 14,
                      fontWeight: 300,
                      padding: [0, 0, 0, 15],
                    },
                  },
                    //指定配置项和数据
                   geo: {
                     // 设置地图的显示信息
                     map: "china", // 注意  哪个区域的就显示哪个区域的名称
                     zoom: 2,
                     label: {
                       normal: {
                         // 设置字体相关信息
                         show: true,
                         // color: "#000",
                         textStyle: {
                           color: "#909090",
                           fontSize: 10,
                           fontFamily: "Arial",
                         },
                       },
                       emphasis: {
                         // 设置鼠标移上去hover效果
                         show: true,
                         color: "#909090",
                       },
                     },
                     roam: true,
                     itemStyle: {
                       normal: {
                         areaColor: "#f8f8f8",
                         borderColor: "#cecece",
                         borderWidth: 1,
                         // shadowColor: "#eef3f3",
                         // shadowBlur: 15,
                       },
                       emphasis: {
                         areaColor: "#cecece",
                       },
                     },
                     // left: "5%",
                     // right: "5%",
                     // top: "5%",
                     // bottom: "5%",
                   },
                   series: [
                     //系列列表
                     {
                       type: "effectScatter", //系列类型 lines为路径图
                       coordinateSystem: "geo", //系列坐标系 geo为地理坐标系
                       geoIndex: 0,
                       data: [],
                     },
                        {
                              name: "Top 5",
                              type: "effectScatter",
                              coordinateSystem: "geo",
                              data: data1,
                              symbolSize: 15,
                              tooltip: {
                                show: false,
                              },
                              markArea: {
                                label: {
                                  show: true,
                                },
                              },
                              encode: {
                                value: 2,
                              },
                              showEffectOn: "render",
                              // 涟漪效果
                              rippleEffect: {
                                brushType: "stroke",
                                color: "red",
                                period: 9,
                                scale: 5,
                              },
                              hoverAnimation: true,
                              label: {
                                formatter: "{b}",
                                position: "right",
                                show: true,
                              },
                              itemStyle: {
                                color: "red",
                                shadowBlur: 2,
                                shadowColor: "#333",
                              },
                              zlevel: 1,
                            },
                          ],
                        };

                echarts.setOption(option); // 使用刚指定的配置项和数据显示图表。

                echarts.on("mousemove", (params) => {
                    this.mapShow = false;
                    this.mapPopY = params.event.offsetX + "px";
                    this.mapPopX = params.event.offsetY + "px";
                    if (params.componentType === "series") {
                      this.mapParkDetail = params.data
                        // if(params.data.imgs){
                        //     this.mapParkDetail.imageURL = params.data.imgs;
                        // }else{
                        //     this.mapParkDetail.imageURL = require('../../assets/设计市场/头像1.jpeg');
                        // }
                        this.mapShow = true;
                    }
                });
            },
            getDesigner(uuid) {
                //this.$router.push("/designModel");
                let routeData = this.$router.resolve({
                    name: "designModel",  params: {uuid: uuid}
                });
                window.open(routeData.href, "_blank");
            },
            printMore(num) {
                if (num == 1) {
                    let routeData = this.$router.resolve({
                        name: "designerList",
                    });
                    window.open(routeData.href, "_blank");
                } else if (num == 2) {
                    let routeData = this.$router.resolve({
                        name: "designList",
                    });
                    window.open(routeData.href, "_blank");
                }

                //this.$router.push("/designList");
            },
            //解决最新需求中一些sapn不能点击跳转到详情页
            handleSectionClick(e){
                let target = e.target;
                if(target.tagName == "SPAN") {
                    this.getDetailMessage(target.dataset.id);
                }
            },
            getDetailMessage(uuid) {
                    //this.$router.push("/designDetails");
                    let routeData = this.$router.resolve({
                        name: "designDetails",  params: {uuid: uuid}
                    });
                    window.open(routeData.href, "_blank");
            },
            getBannerImgs() {
                let params = {
                    groupCode: this.groupCodeImg,
                };
                getBannerList(params)
                    .then((res) => {
                        this.bannerList_imgs = res;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getImgsDetails(index){
                let routeData = this.bannerList_imgs[index].linkUrl;
				if(routeData){
					window.open(routeData, "_blank");
				}
                // window.open(routeData, "_blank");
            },
            getBannerList() {
                let params = {
                    groupCode: this.groupCode,
                };
                getBannerList(params)
                    .then((res) => {
                        this.bannerList = res;
                        this.imgLoad();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
          getTopDesigner(){
            designerListByPage({current:0,pageSize:6}).then(res=>{
              if(res.total>0){
                this.designPeo = [];
                res.list.forEach((item)=>{
                  let designer = {};
                  designer.designerLevels = item.designerLevels;
                  designer.uuid = item.uuid;
                  designer.name = item.nickname;
                  designer.provinces = item.province;
                  designer.city = item.city;
                  designer.works = item.productionNum;
                  designer.fans = item.likeNum;
                  designer.order = 0;
                  designer.introduction = item.introduction;
                  designer.imgs = item.iconUrl;
                  if(item.designerPassAttachmentList != null && item.designerPassAttachmentList.length > 0) {
                    item.designerPassAttachmentList.forEach((item, index) => {
                      if(designer.imgsMess == null){
                        designer.imgsMess = item.fileUrl;
                      }
                    });
                  }
                  let location = [];
                  location.push(item.lng);
                  location.push(item.lat);
                  designer.value = location;
                  designer.userId = item.userId
                  designer.hasLiked = item.hasLiked;
                  this.designPeo.push(designer);
                });
              }
            })
          },
            getDesigners(){
                designerList({}).then((res) => {
                    this.designPeo1 = [];
                    if(res != null && res.length > 0){
                        res.forEach((item) => {
                            let designer = {};
                            designer.designerLevels = item.designerLevels;
                            designer.uuid = item.uuid;
                            designer.name = item.nickname;
                            designer.provinces = item.province;
                            designer.city = item.city;
                            designer.works = item.productionNum;
                            designer.fans = item.likeNum;
                            designer.order = 0;
                            // designer.opinion = "98%";
                            designer.introduction = item.introduction;
                            designer.imgs = item.iconUrl;
                            if(item.designerPassAttachmentList != null && item.designerPassAttachmentList.length > 0) {
                                item.designerPassAttachmentList.forEach((item, index) => {
                                    if(designer.imgsMess == null){
                                        designer.imgsMess = item.fileUrl;
                                    }
                                });
                            }
                            let location = [];
                            location.push(item.lng);
                            location.push(item.lat);
                            designer.value = location;
                            designer.userId = item.userId
                            designer.hasLiked = item.hasLiked;
                            // this.mapParkDetail.hasLiked = item.hasLiked
                            this.designPeo1.push(designer);
                        });
                      this.getMapData();

                    }
                })
            },
            getDemands(){
                let param ={};
                if(this.isLogin){
                    param = {
                        // status:  "PASS",
                      isLogin: 1,
                      current:0,
                      pageSize:8
                    }
                }else{
                    param = {
                        // status:  "PASS",
                      isLogin: 0,
                      current:0,
                      pageSize:8
                    }
                }
              queryDemandList(param).then((res) => {
                    if(res != null && res.total > 0){
                        res.list.forEach((item) => {
                          let demand = {};
                          demand.uuid = item.uuid;
                          demand.title = item.demandName;
                          demand.creator = item.creator;
                          demand.type=item.demandType;
                          demand.name=item.demandClassName;
                          demand.money = item.lowPreAmount + '-' + item.highPreAmount;
                          demand.size = item.demandDes ==null? "": item.demandDes;
                          if(item.demandType == 'MODEL') {
                            demand.describe = item.specificationsStart + '~' + item.specificationsEnd + 'cm';
                          }
                          demand.date = item.expectedDeliveryTime;
                          demand.state = item.statusCn;
                          this.demandList.push(demand);
                          this.newDemandList.push(demand);
                        });
                    }
                })
            },
            isIdentityUser(){
                if(this.isLogin){
                    let data = {
                        userUuid: this.userMessages.uuid
                    }
                    /*if(this.userMessages.uuid && this.userMessages.identity != 'ENTERPRISE'){
                        getCredentials(data).then((res) => {
                            if(res.success){
                                if(res.data.status == 'APPROVE' && res.data.identityType == 'PERSONAL'){
                                    this.$router.push('/designRelease')
                                }else if(res.data.status == 'SUBMIT' && res.data.identityType == 'PERSONAL'){
                                    this.$message({
                                        type: "success",
                                        message: "用户实名认证审核中,认证通过后再来执行当前操作！",
                                    });
                                }else if(res.data.status == 'REJECT' && res.data.identityType == 'PERSONAL'){
                                    this.$message({
                                        type: "success",
                                        message: "用户实名认证信息被拒绝，请至个人中心查看详情！",
                                    });
                                }
                            }else{
                                // this.$message({
                                //     type: "error",
                                //     message: "用户个人实名认证信息未提交,认证通过后再来执行当前操作！",
                                // });
                                this.$confirm('请先进行实名认证！', '提示', {
                                    confirmButtonText: '去认证',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    window.sessionStorage.setItem("userServeId",'10')
                                    this.$router.push('/userCenter/10')
                                }).catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: '已取消'
                                    });
                                });
                            }
                        })
                    }else if(this.userMessages.identity == 'ENTERPRISE' || this.userMessages.identity == 'STAFF'){
                        this.$router.push('/designRelease')
                    }*/

                  this.$router.push('/designRelease')
                }else{
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                        duration:1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                        onClose:()=>{
                            //跳转页面或执行方法
                            this.$router.push('/login')
                        }
                    });
                }
            },
            isDesigner(){
                // console.log("isDesigner1:" + this.userMessages.uuid);
                if(this.isLogin){
                    let data = {
                        userUuid: this.userMessages.uuid
                    }
                    if(this.userMessages.uuid){
                        designerByUserId(this.userMessages.uuid).then((res) => {
                            if(res != null && res != ""){
                                // if(res.status == 'PASS'){
                                //     this.$message({
                                //         type: "success",
                                //         message: "当前用户已入驻成功，无需再次入驻",
                                //     });

                                // }else
                                if(res.status == 'AUDIT'){
                                    this.$message({
                                        type: "success",
                                        message: "当前用户设计师认证信息正在审核中",
                                    });
                                }else{
                                    // this.$confirm('当前用户设计师认证失败，是否重新调整认证信息?', '提示', {
                                    //     confirmButtonText: '确定',
                                    //     cancelButtonText: '取消',
                                    //     type: 'warning'
                                    // }).then(() => {
                                        this.$router.push('/designerIn');
                                    // }).catch(() => {
                                    // });

                                }
                            }else{
                              debugger
                                couldIn().then((resp) => {
                                    // if(resp.success){
                                        this.$router.push('/designerIn')
                                    // }else{
                                        // if(resp.message == '您的实名认证申请正在审核中，请通过后再进行设计师入驻申请！') {
                                        //     this.$confirm(resp.message, '提示', {
                                        //         confirmButtonText: '查看',
                                        //         cancelButtonText: '取消',
                                        //         type: 'warning'
                                        //     }).then(() => {
                                        //         window.sessionStorage.setItem("userServeId",'10')
                                        //         this.$router.push('/userCenter/10')
                                        //     }).catch(() => {
                                        //     });
                                        // }
                                        // else if (resp.message == '请先进行实名认证，通过后再进行设计师入驻申请！'){
                                        //     this.$confirm(resp.message, '提示', {
                                        //         confirmButtonText: '去认证',
                                        //         cancelButtonText: '取消',
                                        //         type: 'warning'
                                        //     }).then(() => {
                                        //         window.sessionStorage.setItem("userServeId",'10')
                                        //         this.$router.push('/userCenter/10')
                                        //     }).catch(() => {
                                        //     });
                                        // }
                                        // else {
                                        //     this.$message({
                                        //         type: "error",
                                        //         message: resp.message,
                                        //     });
                                        // }
                                    // }
                                });
                               /* getCredentials(data).then((resp) => {
                                    if(resp.success){
                                        if(resp.data.status != 'REJECT' && resp.data.identityType == 'ENTERPRISE'){
                                            this.$message({
                                                type: "success",
                                                message: "当前用户为企业用户，无法进行设计师认证！",
                                            });
                                        }else if(resp.data.status == 'REJECT' && resp.data.identityType == 'ENTERPRISE'){
                                            this.$router.push('/designerIn')
                                        }else if(resp.data.status == 'APPROVE' && resp.data.identityType == 'PERSONAL'){
                                            this.$router.push('/designerIn')
                                        }else if(resp.data.status == 'SUBMIT' && resp.data.identityType == 'PERSONAL'){
                                            this.$message({
                                                type: "success",
                                                message: "用户实名认证审核中,认证通过后再来执行当前操作！",
                                            });
                                        }else if(resp.data.status == 'REJECT' && resp.data.identityType == 'PERSONAL'){
                                            this.$message({
                                                type: "success",
                                                message: "用户实名认证信息被拒绝，请至个人中心查看详情！",
                                            });
                                        }
                                    }else{
                                        this.$message({
                                            type: "error",
                                            message: "用户个人实名认证信息未提交,认证通过后再来执行当前操作！",
                                        });
                                    }
                                })*/
                            }
                        });

                    }

                }else{
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                        duration:1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                        onClose:()=>{
                            //跳转页面或执行方法
                            this.$router.push('/login')
                        }
                    });

                }
            },
          startChat(targetUserId) {
            if (this.isLogin) {
              let user = this.$store.state.isUsermessage;
              getRongCloudUser(targetUserId).then(res=> {
                // console.log('targetUserId-------' + targetUserId);
                // console.log(res);
                this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
              });
            } else {
              this.$message({
                type: "success",
                message: "您需要先登录哦！",
              });
              this.$router.push('/login')
            }
          },

          replyMessage() {
            if (this.isLogin) {
              let user = this.$store.state.isUsermessage;
              this.$refs.chatDialogRef.initReply(user.uuid,user.name,user.headUrl);
            } else {
              this.$message({
                type: "success",
                message: "您需要先登录哦！",
              });
              this.$router.push('/login')
            }
          },
            liked(designer,index) {
                if (this.isLogin) {
                  let params = {
                      likeType: 'DESIGNER',
                      serviceType: 'LIKE',
                      designerUuid: designer.uuid,
                  };
                  if(this.userMessages.uuid == designer.userId){
                      this.$message({
                          type: "success",
                          message: "不能关注自己！",
                      });
                      return ;
                  }else {
                    like(params).then((res) => {
                        if(res && res.success){
                            this.$message({
                                type: "success",
                                message: res.message,
                            });
                            this.getDesigners();
                            this.mapShow = false
                            this.mapParkDetail.hasLiked = !this.mapParkDetail.hasLiked
                        }
                    });
                  }
                } else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push('/login')
                }
            },
            },

    };
</script>

<style scoped lang="less">
    .lookingMasterCard {
        margin-bottom: 22px !important;

        .fMaster {
            border-bottom: 1px solid #f2f2f2;
            padding-left: 20px;
            display: flex;
            justify-content: space-between;

            .lookingMasterCardLeft {
                padding-top: 30px;
                display: flex;

                .avatar {
                    width: 88px;
                    height: 88px;
                    cursor: pointer;
                    img {
                        border-radius: 100%;
                        width: 100%;
                        height: 100%;
                    }
                }
                .fMasterInfoName {
                    padding-top: 0;
                    font-size: 18px;
                    color: #333;
                    margin: 0;
                }

                .fMasterInfoAddr {
                    padding-top: 9px;
                    font-size: 14px;
                    color: #666;
                }
            }

            .lookingMasterCardRight {
                width: 216px;
                height: 162px;
                float: right;
            }
        }

        .fMasterDesc {
            margin: 0;
            padding: 10px 20px 0 20px;
            border-top: none;

            p {
                height: 60px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                line-height: 27px;
                color: #666;
            }
        }
    }

    .container {
        width: 1200px;
        margin: -30px auto;
        /deep/.el-col-6 {
            height: 324px;
        }
        .bannerImgs {
            display: flex;
            align-items: center;
            .bannerImgs_carousel {
                width: 1100px;
                cursor: pointer;
            }
            .bannerImgs_more {
                width: 84px;
                height: 286px;
                line-height: 286px;
                text-align: center;
                background: #efefef;
                margin-left: 16px;
                font-size: 14px;
                color: #666;
                cursor: pointer;
            }
        }
    }

    .newRq {
        background: #f1f5fe;
        height: 70px;
        line-height: 65px;

        .newRqCont {
            display: flex;
            justify-content: space-between;
            width: 1200px;
            margin: 0 auto;

            .newRqCont_text {
                height: 70px;
                overflow: hidden;
                .newRqCont_textSS {
                    margin-left: 50px;
                    width: 800px;
                    overflow: hidden;
                    font-size: 14px;
                    color: #777;
                    .newDemandListItem {
                        /deep/ .seamlessScroll {
                            div:nth-of-type(1) {
                                display: flex;
                                width: max-content !important;
                            }
                        }
                        span {
                            margin-right: 30px;
                        }
                        span:hover{
                            color: #409EFF;
                        }
                    }
                }
            }
        }

        .sMenuBtn {
            /deep/ .el-button {
                width: 120px;
                font-weight: normal;
            }

            /deep/ .el-button--default {
                color: #157efb;
                border: 1px solid #157efb;
            }
        }
    }

    .printTitle {
        color: #1f7de9;
        font-weight: bold;
        margin-top: 60px;
        margin-bottom: 15px;

        span.more {
            font-weight: normal;
            cursor: pointer;
            font-size: 12px;
            float: right;
            margin-top: 10px;
        }

        .more i {
            color: #505050 !important;
        }
    }

    .box-card {
        border: 1px solid #e3e3e3;
        margin-bottom: 30px;
        position: relative;
        width: 100%;
    }

    .fMaster {
        display: flex;
        position: relative;

        /deep/ .el-avatar--96 {
            width: 80px;
            height: 80px;
        }
    }

    .fMasterInfo {
        flex: 1;
        margin-left: 10px;

        .fMasterInfoName {
            margin-bottom: 10px;
            cursor: pointer;
        }

        .fMasterInfoAddr {
            font-size: 12px;
            color: #808080;
        }

        .fMasterInfoAddr i {
            margin-right: 5px;
        }

        .fMasterAna {
            font-size: 12px;
            margin: 20px 0;
        }

        .fMasterAna span.numBlue {
            color: #157efb;
            margin-left: 5px;
        }

        .fMasterBtn {
            /deep/ .el-button {
                font-weight: normal;
            }

            /deep/ .el-button--default {
                color: #157efb;
                border: 1px solid #157efb;
            }
        }
    }

    .fMasterDesc {
        margin: 20px -20px 0;
        padding: 20px 20px 0;
        font-size: 14px;
        border-top: 1px solid #e3e3e3;
    }
    .listTag{
        position: absolute;
        right: 15px;
        top: 16px;
        font-size: 12px;
        color: #1ED76D;
        font-weight: bold;
        width: 50px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border-radius: 6px;
        background: rgba(30, 215, 109, .13);
        &.finishTag{
            background: rgba(0, 0, 0,.13);
            color: #000;
        }
        &.pastTag{
            background: rgba(252, 98, 96, .13);
            color: #F66565;
        }
    }
    .rqTitle {
        font-size: 16px;
        font-weight: normal;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 10px;
        width: 180px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .rqPrice {
        font-size: 14px;
        color: #157efb;
        border: 1px solid #157efb;
        padding: 5px 20px 5px 70px;
        position: relative;
        width: fit-content;

        span.tagBlue {
            background-color: #157efb;
            color: #fff;
            font-size: 12px;
            width: 50px;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .rqDetail {
        margin-top: 20px;
        height: 138px;
        dt {
            float: left;
            width: 70px;
            color: #000;
            font-size: 13px;
            font-weight: 400;
            text-align: left;
            line-height: 24px !important;
        }

        dd {
            color: #808080;
            font-size: 13px;
            line-height: 24px !important;
            margin-left: 80px;
            margin-bottom: 8px;
        }
    }

    .rqFooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f1f5fe;
        border: 1px solid #e3e3e3;
        margin: 0 -21px -21px;
        position: relative;

        span {
            cursor: pointer;
            display: inline-block;
            width: 50%;
            text-align: center;
            font-size: 13px;
            height: 50px;
            color: #157efb;

            line-height: 50px;
        }

        span a {
            color: #157efb;
        }

        span:hover {
            color: rgba(21, 126, 251, 0.8);
        }

        :after {
            position: absolute;
            content: "";
            width: 1px;
            background-color: #e3e3e3;
            height: 34px;
            top: 8px;
            left: 50%;
        }
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
    }

    /deep/ .el-carousel__button {
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }

    .map {
        margin-top: 30px;
        height: 500px;
        text-align: center;
        line-height: 500px;
        background-color: #f0f0f0;
    }

    // 地图
    .mapPosition {
        position: relative;
        background: #9fd7fc;

        .mapInput {
            position: absolute;
            z-index: 100;
            top: 3%;
            left: 10%;
            height: 33px;
            // align-items: center;
            /deep/ .el-input {
                height: 33px;
                width: 221px;
            }

            /deep/ .el-input__inner {
                height: 33px;
                border-radius: 0;
            }
			/deep/ .el-input__suffix{
				top: -3px;
			}
            input {
                width: 221px;
                height: 100%;
                background: #fff;
                border: none;
                padding: 0px 14px;
            }

            i {
                display: inline-block;
                height: 100%;
                width: 40px;
                line-height: 33px;
                text-align: center;
                background: #157efb;
                color: #fff;
                font-size: 18px;
            }
        }
    }

    // 地图弹框样式
    .maps {
        position: absolute;
        z-index: 100;
        background: rgba(255, 255, 255, 0.797);
        padding: 20px;
        border-radius: 10px;
        max-width: 400px;

        .mapImg {
            width: 100px;
            border-radius: 50%;
            margin-right: 20px;
            flex-shrink: 0;

            /deep/ .el-image {
                width: 90px;
                height: 90px;
                border-radius: 50%;
            }

            img {
                // border-radius: 50%;
                width: 90px;
                height: 90px;
                border-radius: 50%;
                display: inline-block;
            }
            .mapImgIcon {
              margin-top: 10px;
              font-size: 14px;
              text-align: center;
              display: flex;
              align-items: center;
              i {
                color: #157efb;
                font-size: 18px;
                margin-right: 3px;
              }
              p {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
        }

        .mapMess {
          width: 70%;
            .mapMessT {
                font-size: 18px;
                font-weight: 500;
            }
            .mapMessText {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 14px;
            }
            .mapMessWork {
              font-size: 14px;
              margin: 8px 0;
              align-items: center;
              p {
                margin-right: 10px;
              }
              span {
                color: #157efb;
                font-weight: bold;

              }
              .gangMess {
                display: inline-block;
                width: 2px;
                height: 14px;
                background: #666;
                margin: 0 12px;
              }
            }

            .mapMessBox {
                align-items: center;
                margin: 10px 0;

                .mapMessP {
                }

                i {
                    width: 2px;
                    height: 15px;
                    background: #cccccc;
                    margin: 0 10px;
                    display: inline-block;
                }
            }

            .mapMessBut {
                margin-top: 20px;
                display: flex;

                button {
                    border-radius: 3px;
                    color: #157efb;
                    padding: 6px 12px;
                    border: 1px solid #157efb;
                    background: #fff;
                    margin-right: 15px;
                    width: 130px;
                    cursor: pointer;
                }
                button:nth-child(2) {
                  border-radius: 3px;
                  color: #fff;
                  padding: 6px 12px;
                  border: 1px solid #157efb;
                  background: #157efb;
                }
            }
        }
    }
</style>
<style lang="less">
    .lookingMasterCard {
        .el-card__body {
            padding: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/design/index.vue